module.exports = __webpack_public_path__ + "static/media/vadilal-embarressed.ffc456c3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/vadilal-embarressed.jpg
// module id = 150
// module chunks = 0